export const localStateMapper = () => {

  const mapper = [];
  return mapper['230']= {
    "al":"3583",
    "ak":"3584",
    "az":"3585",
    "ar":"3586",
    "ca":"3587",
    "co":"3588",
    "ct":"3589",
    "de":"3590",
    "dc":"3633",
    "fl":"3591",
    "ga":"3592",
    "hi":"3593",
    "id":"3594",
    "il":"3595",
    "in":"3596",
    "ia":"3597",
    "ks":"3598",
    "ky":"3599",
    "la":"3600",
    "me":"3601",
    "md":"3602",
    "ma":"3603",
    "mi":"3604",
    "mn":"3605",
    "ms":"3606",
    "mo":"3607",
    "mt":"3608",
    "ne":"3609",
    "nv":"3610",
    "nh":"3611",
    "nj":"3612",
    "nm":"3613",
    "ny":"3614",
    "nc":"3615",
    "nd":"3616",
    "oh":"3617",
    "ok":"3618",
    "or":"3619",
    "pa":"3620",
    "ri":"3621",
    "sc":"3622",
    "sd":"3623",
    "tn":"3624",
    "tx":"3625",
    "ut":"3626",
    "vt":"3627",
    "va":"3628",
    "wa":"3629",
    "wv":"3630",
    "wi":"3631",
    "wy":"3632"
  };
}
